import * as React from "react"
import { configOptions } from "./config"

export const ToolbarWidgetDescription = {
  name: 'Toolbar',
  component: React.lazy(() => import('./toolbar-widget' )),
  label: 'Toolbar',
  variables: configOptions
}
